import {
  Box,
  SimpleGrid,
  Stack,
  Grid,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Button,
  Switch,
  useToast,
  useColorModeValue
} from "@chakra-ui/react";
import UsersTable from "views/admin/users/components/UsersTable";
import TextFilter from "components/filter/TextFilter";
import Card from "components/card/Card.js";

import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Settings() {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [loading, setLoading] = useState(false);
  const [buyRate, setBuyRate] = useState(0)
  const [sellRate, setSellRate] = useState(0)
  const [withdrawalFee, setWithdrawalFee] = useState(0)
  const [disableWithdrawal, setDisableWithdrawal] = useState(false)
  const [disableBuy, setDisableBuy] = useState(false)
  const [disableSell, setDisableSell] = useState(false)

  const token = localStorage.getItem("authToken");
  const toast = useToast();

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      setLoading(true);
      const { data: response } = await axios.patch(
        SERVER_URL + "/settings",
        {
          buyRate: buyRate,
          sellRate: sellRate,
          withdrawalFee: withdrawalFee,
          withdrawal: disableWithdrawal,
          buy: disableBuy,
          sell: disableSell
         },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
      }
      if (response.success) {
        setLoading(false);
        toast({
          title: response.message || "User updated",
          status: "success",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
    } catch (error) {
      setLoading(false);
      toast({
        title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  const getSettings = async()=>{
    try{
      setLoading(true);
      const {data:response} = await axios.get(SERVER_URL+'/settings',{
        headers:{
          "Authorization":`Bearer ${token}`
        }
      });
      if(response.error){
        toast({
          title: response.error || "An error occured",
          status: 'error',
          duration: 9000,
          position:'top-right',
          isClosable: true,
        })
      }
      if(!response.success){
        toast({
          title: response.message || "An error occured",
          status: 'error',
          duration: 9000,
          position:'top-right',
          isClosable: true,
        })
      }
      if(response.success){
          setLoading(false);
          setBuyRate(response.data.buyRate);
          setSellRate(response.data.sellRate);
          setWithdrawalFee(response.data.withdrawalFee);
          setDisableWithdrawal(response.data.withdrawal);
          setDisableBuy(response.data.buy);
          setDisableSell(response.data.sell);
         return
       }
     }
    catch(error){
      setLoading(false);
      toast({
        title: error.message || "An error occured",
        status: 'error',
        duration: 9000,
        position:'top-right',
        isClosable: true,
      })
    }
}

  useEffect(() => {
    getSettings();
  }, []);

  return (
    <Box
      pt={{ base: "130px", md: "80px", xl: "80px" }}
      overflow="hidden"
      width={{ base: "100%", sm: "100%", md: "100%" }}
    >
      <SimpleGrid columns={{ base: 1, sm: 1, md: 2, lg: 2 }}>
        <Card align="center" p="20px">
          <Stack
            spacing={2}
            w={"full"}
            bg={useColorModeValue("white", "gray.700")}
            p={6}
            my={5}
          >
            <FormControl id="buyRate" isRequired>
              <FormLabel><b>Buy Rate</b></FormLabel>
              <Input
                type="number"
                value={buyRate}
                onChange={(event) => setBuyRate(event.target.value)}
              />
              <FormHelperText>
                The rate at which users can buy from your site.
              </FormHelperText>
            </FormControl>

            <FormControl id="sellRate" isRequired>
              <FormLabel><b>Sell Rate</b></FormLabel>
              <Input
                type="number"
                value={sellRate}
                onChange={(event) => setSellRate(event.target.value)}
              />
              <FormHelperText>
                The rate at which users can sell to your site.
              </FormHelperText>
            </FormControl>

            <FormControl id="withdrawalFee" isRequired>
              <FormLabel><b>Withdrawal Fee</b></FormLabel>
              <Input
                type="number"
                value={withdrawalFee}
                onChange={(event) => setWithdrawalFee(event.target.value)}
              />
              <FormHelperText>The fee for withdrawing funds.</FormHelperText>
            </FormControl>

            <FormControl display="flex" alignItems="center">
              <Switch
                id="disableWithdrawal"
                isChecked={disableWithdrawal}
                onChange={(event) => setDisableWithdrawal(event.target.checked)}
              />
              <FormLabel htmlFor="disableWithdrawal" mb="0">
              <b>&nbsp;Disable Withdrawal</b>
              </FormLabel>
            </FormControl>

            <FormControl display="flex" alignItems="center">
              <Switch
                id="disableBuy"
                isChecked={disableBuy}
                onChange={(event) => setDisableBuy(event.target.checked)}
              />
              <FormLabel htmlFor="disableBuy" mb="0">
              <b>&nbsp;Disable Buy</b>
              </FormLabel>
            </FormControl>

            <FormControl display="flex" alignItems="center">
              <Switch
                id="disableSell"
                isChecked={disableBuy}
                onChange={(event) => setDisableSell(event.target.checked)}
              />
              <FormLabel htmlFor="disableSell" mb="0">
              <b>&nbsp;Disable Sell</b>
              </FormLabel>
            </FormControl>

            <Button
              bg={"blue.400"}
              color={"white"}
              w="full"
              borderRadius="20"
              _hover={{
                bg: "blue.500",
              }}
              mt={10}
              isLoading={loading}
              loadingText={'Wait...'}
              onClick={handleSubmit}
            >
              Update
            </Button>
          </Stack>
        </Card>
      </SimpleGrid>
    </Box>
  );
}
